import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ESessionStore, FeatureFlags } from '../../data/Constants';
import { ConfigurationApi } from '../../api/ConfigurationApi';
import { AppState } from '../AppStore';
import { SessionStore } from '../../services/SessionStore';
import { getFeatureFlags } from '../../services/ClaimsHelper';

import type { IClaimsData } from '../../../types';

const defaultClaimsData = {
  claims: null,
  featureFlags: FeatureFlags,
} as IClaimsData;

export const getClaims = createAsyncThunk(
  'claimsData/getClaims',
  async (action: { token: string }) => {
    return ConfigurationApi.getClaims(action);
  }
);

const claimsDataSlice = createSlice({
  name: 'claimsData',
  initialState: defaultClaimsData,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getClaims.fulfilled, (state, action) => {
      if (action.payload.claims) {
        const featureFlags = getFeatureFlags(action.payload, state);
        state.claims = action.payload.claims;
        state.featureFlags = featureFlags;
        SessionStore.set(ESessionStore.Channel, action.payload.claims.channel);
      }
    });
  },
});

export const claimsData = (state: AppState) => state;

export default claimsDataSlice.reducer;
